import React, { FC } from 'react';
import { ReportErrorModalLine } from './ReportErrorModalLine';
import {
  ModalScrollableHeader,
  ModalScrollableContainer,
} from '../../../components/modal';
import { UserContextType } from '../../../user/user.types';
import { WithModalProps } from '../../../components/modal/withModal';

type Props = {
  isOpen: boolean;
  loggedIn: UserContextType['loggedIn'];
  verified: boolean;
  lawyerName: string;
  lawyerId: string;
  onRequestClose: () => void;
  openModal: WithModalProps['openModal'];
};

export const ReportErrorModal: FC<Props> = ({
  isOpen = false,
  onRequestClose = () => {},
  loggedIn,
  verified,
  lawyerName,
  lawyerId,
  openModal,
}) => {
  const commonProps = {
    closeParentModal: onRequestClose,
    loggedIn,
    verified,
    lawyerName,
    lawyerId,
    openModal,
  };
  return (
    <ModalScrollableContainer isOpen={isOpen} onRequestClose={onRequestClose}>
      <ModalScrollableHeader
        title="Signaler une erreur"
        onClose={onRequestClose}
      />
      <ReportErrorModalLine
        className="entity__border-bottom"
        title="Décision attribuée à tort"
        subTitle="Une décision a été référencée sur ma page à tort"
        url="https://doctrine.typeform.com/to/KKsJvP"
        {...commonProps}
      />
      <ReportErrorModalLine
        className="entity__border-bottom"
        title="Décision non référencée"
        subTitle="Une de mes décisions n'est pas référencée sur ma page"
        url="https://doctrine.typeform.com/to/KjW5FS"
        {...commonProps}
      />
      <ReportErrorModalLine
        title="Domaine du droit incorrect"
        subTitle="Une décision sur ma page est dans le mauvais domaine du droit"
        url="https://doctrine.typeform.com/to/E2UF1K"
        {...commonProps}
      />
    </ModalScrollableContainer>
  );
};
